module.exports = __webpack_public_path__ + "static/img/location.8abe69fb.png";